import { render, staticRenderFns } from "./FormularioAddMujer.vue?vue&type=template&id=e5462330&scoped=true"
import script from "./FormularioAddMujer.vue?vue&type=script&lang=js"
export * from "./FormularioAddMujer.vue?vue&type=script&lang=js"
import style0 from "./FormularioAddMujer.vue?vue&type=style&index=0&id=e5462330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5462330",
  null
  
)

export default component.exports